(() => {
  angular
    .module('complianceFrameworkApp.socialMediaCompliance')
    .controller('ReminderFormController', ReminderFormController);

  /* ngInject */
  function ReminderFormController($state, $stateParams, Flash, reminderService, sessionService) {
    const vm = this;

    vm.id = $stateParams.id;
    vm.reminder = {};
    vm.saveReminder = saveReminder;

    activate();

    function activate() {
      if (vm.id) {
        getReminder();
      }
    }

    function getReminder() {
      reminderService(sessionService.getAuthToken()).get({ id: vm.id }, response => vm.reminder = response);
    }

    function saveReminder() {
      if (vm.id) {
        reminderService(sessionService.getAuthToken()).update({ id: vm.id }, vm.reminder,
          _ => {
            $state.go('application.social_media_compliance.reminders');
            Flash.create('success', 'Reminder successfully updated.');
          },
          _ => {
            Flash.create('danger', 'An error occurred with the submission. Please correct the following errors on the form and resubmit.'); 
          }
        );
      } else {
        reminderService(sessionService.getAuthToken()).save(vm.reminder,
        _ => {
          $state.go('application.social_media_compliance.reminders');
          Flash.create('success', 'Reminder successfully created.');
        },
        _ => {
          Flash.create('danger', 'An error occurred with the submission. Please correct the following errors on the form and resubmit.'); 
        });
      }
    }
  }
})();
